import type { JSX } from 'react'

import {
  DropdownMenu,
  EllipsisVerticalIcon,
  IconButton,
} from '@buffer-mono/popcorn'

import styles from './PostNotes.module.css'
import { NoteReadStateIcon } from './NoteReadStateIcon'
import { usePostNotesContext } from './PostNotesProvider'

export function NotesFeedActions(): JSX.Element | null {
  const { notes, create, readState, markRead, markUnread } =
    usePostNotesContext()
  const newestConfirmed = create.confirmedNotes[0]
  const newestLoaded = notes.status === 'ready' ? notes.notes[0] : undefined
  const latestNoteId =
    newestConfirmed && (!newestLoaded || newestConfirmed.id >= newestLoaded.id)
      ? newestConfirmed.id
      : newestLoaded?.id

  if (
    readState.status !== 'ready' ||
    !readState.state?.unreadNoteCount ||
    !latestNoteId
  )
    return null

  const pending = markRead.pending || markUnread.pending

  return (
    <DropdownMenu
      className={styles.feedActionsMenu}
      modal={false}
      trigger={
        <IconButton
          label="Notes actions"
          tooltip="Notes actions"
          size="small"
          type="button"
          variant="tertiary"
          disabled={pending}
        >
          <EllipsisVerticalIcon size="xsmall" />
        </IconButton>
      }
    >
      <DropdownMenu.Item
        disabled={pending}
        onSelect={() => void markRead.submit(latestNoteId)}
      >
        <NoteReadStateIcon state="read" />
        Mark all as read
      </DropdownMenu.Item>
    </DropdownMenu>
  )
}
